/**
 * @generated SignedSource<<ff797ba81e43732ea01894427254308f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLOrganizationalMemoryType = "BEST_PRACTICE" | "FACT" | "QUERY" | "RESOURCE" | "UNKNOWN" | "%future added value";
export type OrganizationalMemorySource = "ALERT_THREAD" | "CHROME_EXTENSION" | "DASHBOARD" | "DISCORD" | "DOCUMENT" | "INCIDENT_CHANNEL" | "ONBOARDING" | "SLACK" | "SYSTEM" | "TOOL_ADD" | "UI" | "UI_ADD" | "%future added value";
export type CorrectOrganizationalMemoryInput = {
  body: any;
  correctionReason?: string | null | undefined;
  memoryId: any;
};
export type EditMemoryModalMutation$variables = {
  input: CorrectOrganizationalMemoryInput;
};
export type EditMemoryModalMutation$data = {
  readonly correctOrganizationalMemory: {
    readonly __typename: "CorrectOrganizationalMemoryError";
    readonly message: string;
  } | {
    readonly __typename: "CorrectOrganizationalMemorySuccess";
    readonly memory: {
      readonly body: {
        readonly __typename: "GraphQLGenericLearningBody";
        readonly knowledge: string | null | undefined;
        readonly reasoning: string | null | undefined;
        readonly scope: string | null | undefined;
        readonly type: string | null | undefined;
      } | {
        readonly __typename: "GraphQLQueryBody";
        readonly query: any;
        readonly queryDescription: string | null | undefined;
        readonly queryType: string | null | undefined;
        readonly question: string | null | undefined;
      } | {
        readonly __typename: "GraphQLResourceBody";
        readonly content: any;
        readonly name: string;
        readonly resourceType: string;
        readonly systemDescription: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly id: any;
      readonly memoryType: GraphQLOrganizationalMemoryType;
      readonly score: number | null | undefined;
      readonly source: OrganizationalMemorySource;
    };
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type EditMemoryModalMutation = {
  response: EditMemoryModalMutation$data;
  variables: EditMemoryModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "correctOrganizationalMemory",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLOrganizationalMemory",
            "kind": "LinkedField",
            "name": "memory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memoryType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "score",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scope",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "knowledge",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reasoning",
                        "storageKey": null
                      }
                    ],
                    "type": "GraphQLGenericLearningBody",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "queryType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "queryDescription",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "query",
                        "storageKey": null
                      }
                    ],
                    "type": "GraphQLQueryBody",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resourceType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "systemDescription",
                        "storageKey": null
                      }
                    ],
                    "type": "GraphQLResourceBody",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "CorrectOrganizationalMemorySuccess",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "CorrectOrganizationalMemoryError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMemoryModalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMemoryModalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e6cc9b53dc6ed8b4bccc1ac5abbab773",
    "id": null,
    "metadata": {},
    "name": "EditMemoryModalMutation",
    "operationKind": "mutation",
    "text": "mutation EditMemoryModalMutation(\n  $input: CorrectOrganizationalMemoryInput!\n) {\n  correctOrganizationalMemory(input: $input) {\n    __typename\n    ... on CorrectOrganizationalMemorySuccess {\n      memory {\n        id\n        memoryType\n        source\n        score\n        body {\n          __typename\n          ... on GraphQLGenericLearningBody {\n            type\n            scope\n            knowledge\n            reasoning\n          }\n          ... on GraphQLQueryBody {\n            queryType\n            question\n            queryDescription\n            query\n          }\n          ... on GraphQLResourceBody {\n            resourceType\n            name\n            content\n            systemDescription\n          }\n        }\n      }\n    }\n    ... on CorrectOrganizationalMemoryError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9b613b520af34dafa205cd8a0957bd1";

export default node;
